import React, { useEffect, useState } from "react";
import {
  Modal,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";

const ConsultaModal = ({
  isOpen,
  toggle,
  consultaEditavel,
  onClienteEdicao,
}) => {
  const [nomeCompleto, setNomeCompleto] = useState("");

  const [bimestre, setbimestre] = useState("");

  const [perguntas, setPerguntas] = useState([]);

  async function getPerguntas() {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/avaliacoes/formulario/1`
      );
      const data = await response.json();
      const grouped = data.data.reduce((acc, item) => {
        if (!acc[item.nome]) {
          acc[item.nome] = [];
        }
        acc[item.nome].push(item);
        return acc;
      }, {});
      const perguntasAgrupadas = Object.keys(grouped).map((key) => {
        return {
          id: grouped[key][0].id_pergunta,
          titulo: key,
          perguntas: grouped[key],
        };
      });
      console.log(perguntasAgrupadas);
      setPerguntas(perguntasAgrupadas);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    console.log(consultaEditavel);
    // getPerguntas();
  }, [consultaEditavel]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!bimestre) {
      onClienteEdicao("Selecione o período de avaliação!", "error");
      return;
    }

    perguntas.forEach((pergunta) => {
      const resposta = document.querySelector(
        `input[name=pergunta${pergunta.id}]:checked`
      );

      if (!resposta) {
        onClienteEdicao("Responda todas as perguntas!", "error");
        return;
      }
    });

    const respostas = perguntas.map((pergunta, index) => {
      const resposta = document.querySelector(
        `input[name=pergunta${pergunta.id}]:checked`
      );
      return {
        pergunta: pergunta.id,
        resposta: resposta ? resposta.value : null,
      };
    });

    const dados_User = JSON.parse(localStorage.getItem("authUser"));
    console.log(dados_User);
    const clienteData = {
      avaliacao: {
        id_professor: dados_User.data.id,
        id_aluno: consultaEditavel.id,
        id_formulario: 1,
        bimestre,
        respostas,
      },
    };

    try {
      fetch(`${process.env.REACT_APP_API}/avaliacoes`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(clienteData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.error) {
            onClienteEdicao(data.message, "error");
          } else {
            onClienteEdicao(`Avaliação cadastrada com sucesso`, "success");
            toggle();
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  const mandarWhatsapp = () => {
    window.open(
      `https://api.whatsapp.com/send?phone=55${consultaEditavel?.telefone}&text=Olá, ${consultaEditavel?.cliente}!`
    );
  };

  const handleVerTudo = () => {
    window.location.href =
      "/perfil-cliente/" +
      (consultaEditavel ? consultaEditavel.id_cliente : "");
  };

  return (
    <Modal size="xl" isOpen={isOpen} toggle={toggle}>
      <div className="modal-header">
        <h5 className="modal-title mt-0">
          Consulta de {consultaEditavel?.cliente}
        </h5>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={toggle}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <Form onSubmit={handleSubmit}>
        <div className="modal-body">
          <Row>
            <Col md={6}>
              <p>
                <strong>Cliente:</strong> {consultaEditavel?.cliente}
              </p>
              <p>
                <strong>Médico:</strong> {consultaEditavel?.medico}
              </p>
              <p>
                <strong>Área:</strong> {consultaEditavel?.area}
              </p>
              <p>
                <strong>Serviço:</strong> {consultaEditavel?.servico}
              </p>
              <p>
                <strong>Status:</strong> {consultaEditavel?.status}
              </p>
              <p>
                <strong>Observação:</strong> {consultaEditavel?.message}
              </p>
              <p>
                <strong>Link do Meet:</strong>{" "}
                <a
                  target="_blank"
                  href={consultaEditavel?.hangoutLink}
                  rel="noreferrer"
                >
                  Clique aqui
                </a>
              </p>
            </Col>
          </Row>

          <Row form>
            {/* Campos do formulário aqui */}
            {/* Exemplo: */}

            <Col md={6}>
              <FormGroup>
                <Label for="bimestre">Atualizar Status</Label>
                <Input
                  type="select"
                  name="bimestre"
                  id="bimestre"
                  value={bimestre}
                  onChange={(e) => setbimestre(e.target.value)}
                >
                  <option value="">Selecione...</option>
                  <option value="1">Primeiro Bimestre</option>
                  <option value="2">Segundo </option>
                  <option value="3">Terceiro</option>
                  <option value="4">Quarto</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </div>
        <div className="modal-footer">
          <Button type="button" color="secondary" onClick={toggle}>
            Cancelar
          </Button>
          <Button type="submit" color="primary">
            Salvar
          </Button>
          <Button type="reset" color="danger" onClick={handleVerTudo}>
            Ver cliente
          </Button>
          <Button type="submit" color="success" onClick={mandarWhatsapp}>
            Enviar Whatsapp
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ConsultaModal;
